export default __webpack_public_path__ + "6b47c0924c1feb5053f6fd896a52e955.png";